import { initPlaces, doGetPlacePredictions, doGetPlaceDetail } from "./places";

export default {
    initPlaces,
    doGetPlacePredictions,
    doGetPlaceDetail,
};
